module.exports = __webpack_public_path__ + "af40daaacef4808cba3a9eaff6f82f0e.png";